import type { ReactNode } from 'react';
import { useSprayTncGate } from '../../hooks/useSprayTncGate';
import SprayTncModal from './SprayTncModal';

interface Props {
  children: ReactNode;
}

/**
 * Wrap each spray page. Renders children normally, but if the current user
 * has not accepted the active spray T&C the blocking modal is overlaid on
 * top. Write endpoints on the backend also enforce this via
 * requireSprayTncAccepted, so the modal cannot be bypassed by navigating
 * directly to an action.
 */
function SprayTncGate({ children }: Props) {
  const { loading, needsAcceptance, tnc, accept } = useSprayTncGate();

  return (
    <>
      {children}
      {!loading && needsAcceptance && tnc && (
        <SprayTncModal tnc={tnc} onAccept={accept} />
      )}
    </>
  );
}

export default SprayTncGate;
